<div class="container">
    <form class="h-full flex flex-col" [formGroup]="form" #formDirective="ngForm">
        <div class="flex flex-col mt-2 justify-between items-center">
            <ng-container *ngIf="this.model">
                <div class="flex mt-4 w-full justify-center">
                    <div class="flex flex-col w-[30%] mr-5">
                        <mat-form-field  class="w-full">
                            <mat-label>{{'USER.USERNAME'| translate}}</mat-label>
                            <input matInput formControlName="username" class="w-full" placeholder="" required>
                            <span class="text input-error w-full" *ngIf="controls.username.hasError('required') && controls.username.pristine === false">
                                {{'REQUIRED'| translate}}
                            </span>
                        </mat-form-field>
                    </div>
                    <div class="flex flex-col w-[30%]">
                        <mat-form-field  class="w-full">
                            <mat-label>{{'EMAIL'| translate}}</mat-label>
                            <input matInput formControlName="email" class="w-full" placeholder="">
                        </mat-form-field>
                        <span class="text input-error" *ngIf="controls.email.hasError('email')">
                            {{'VALID_EMAIL'| translate}}
                        </span>
                    </div>
                </div>
                <div class="flex mt-4 w-full justify-center">
                    <div class="flex flex-col w-[30%] mr-5">
                        <mat-form-field  class="w-full">
                            <mat-label>{{'USER.FIRSTNAME'| translate}}</mat-label>
                            <input matInput formControlName="firstName" class="w-full" placeholder="" required>
                            <span class="text input-error w-full" *ngIf="controls.firstName.hasError('required') && controls.firstName.pristine === false">
                                {{'REQUIRED'| translate}}
                            </span>
                        </mat-form-field>
                    </div>
                    <div class="flex flex-col w-[30%]">
                        <mat-form-field  class="w-full">
                            <mat-label>{{'USER.LASTNAME'| translate}}</mat-label>
                            <input matInput formControlName="lastName" class="w-full" placeholder="" required>
                            <span class="text input-error w-full" *ngIf="controls.lastName.hasError('required') && controls.lastName.pristine === false">
                                {{'REQUIRED'| translate}}
                            </span>
                        </mat-form-field>
                    </div>
                </div>
                <div class="flex mt-4 w-full justify-center">
                    <div class="flex flex-col w-[30%] mr-5">
                        <mat-form-field  class="w-full">
                            <mat-label>{{ "LANG_TRANSLATED" | translate }}</mat-label>
                            <mat-select formControlName="language" class="w-full">
                                <mat-option *ngFor="let lang of USER_LANGUAGES | keyvalue" [value]="lang.value.key">{{lang.value.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="flex flex-col w-[30%]">
                    </div>
                </div>
                <div class="reset-password flex mt-5 w-full">
                    <div class="btn-reset-password" (click)="resetPassword()">
                        <span class="txt-btn">
                            {{'USER.PASSWORD.RESET' | translate}}
                        </span>
                    </div>
                </div>
            </ng-container>
        </div>
    </form>
</div>